import type { JSX } from 'react';

import { InlineMessage } from '@change-corgi/design-system-legacy/components/alerts';

import { RichMediaTextEditorSunrise } from 'src/app/shared/components/richTextEditor';

import { useDescription } from './hooks/useDescription';

export function Description(): JSX.Element {
	const { data, actions } = useDescription();
	return (
		<div id="edit_description" sx={{ '.tox': { height: ['220px !important', '400px !important'] } }}>
			<RichMediaTextEditorSunrise
				initialValue={data.value}
				onEditorChange={actions.handleChange}
				hideLabel
				aria-describedby="description_error"
				aria-required
			/>
			{data.error && (
				<InlineMessage
					id="description_error"
					variant="error"
					labelColor="primary-black"
					size="small"
					fontWeight="normal"
				>
					{data.error}
				</InlineMessage>
			)}
		</div>
	);
}
